import { IAppTranslations } from "./translationsTypes";
import noEthereumProviderSectionTranslationsJson from "./locales/ja/noEthereumProviderSection.json";
import commonsTranslationsJson from "./locales/ja/commons.json";
import domainTranslationsJson from "./locales/ja/domain.json";
import modalsJson from "./locales/ja/modals.json";
import accountConnectionSectionTranslationsJson from "./locales/ja/accountConnectionSection.json";
import explanationTextsJson from "./locales/ja/explanationsTexts.json";
import headerTranslationsJson from "./locales/ja/header.json";
import registerGuardianSectionTranslationsJson from "./locales/ja/registerGuardianSection.json";
import delegatingToAnotherSectionTranslationsJson from "./locales/ja/delegatingToAnotherAccountSection.json";
import guardianDataFormsTranslationsJson from "./locales/ja/gaurdianDataForms.json";
import guardianEditPageTranslationsJson from "./locales/ja/guardianEditPage.json";

export const JAPANESE_TEXTS: IAppTranslations = {
  noEthereumProviderSection: noEthereumProviderSectionTranslationsJson,
  commons: commonsTranslationsJson,
  domain: domainTranslationsJson,
  modals: modalsJson,
  accountConnectionSection: accountConnectionSectionTranslationsJson,
  explanationsTexts: explanationTextsJson,
  header: headerTranslationsJson,
  registerGuardianSection: registerGuardianSectionTranslationsJson,
  delegatingToAnotherAccountSection: delegatingToAnotherSectionTranslationsJson,
  guardianDataForms: guardianDataFormsTranslationsJson,
  guardianEditPage: guardianEditPageTranslationsJson,
};
